if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      let renderSections = this.cartNotification.getSectionsToRender().map((section) => section.id)
      renderSections.push('main-cart-items')

      formData.append('sections', renderSections);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      let extraDelivery = false

      for (let pair of formData.entries()) {
        if (pair[0] == 'properties[_extraDelivery]' && !!pair[1])
        extraDelivery = true
      }
    
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);

          if (extraDelivery) {
            const mainCartItemsText = response.sections['main-cart-items']
            const mainCartItemsElement = document.createElement('div')
            mainCartItemsElement.innerHTML = mainCartItemsText.trim()
            const cartItems = mainCartItemsElement.querySelectorAll('.cart-item')
            let cartVariantIds = []

            cartItems.forEach(el => {
              const variantId = el.getAttribute('variant-id')
              cartVariantIds.push(variantId)
            })

            if (!cartVariantIds.includes(window.customVariables.extraDeliveryProduct)) {
              return fetch(`${routes.cart_add_url}`, {
                method: "POST",
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  'items': [{
                    'id': window.customVariables.extraDeliveryProduct,
                    'quantity': 1,
                    }],
                })
              })
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  const original = document.querySelector('.product-form');
  const sticky = document.querySelector('.product-form__buttons');

  if (!original || !sticky) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && window.innerWidth > 750) {
        sticky.classList.add('active');
        original.classList.add('active');
      } else {
        sticky.classList.remove('active');
        original.classList.remove('active');
      }
    });
  }, { threshold: 0 });

  observer.observe(original);
});
